import { Injectable } from '@angular/core';
import { QueryManagerService } from 'finzzle-angular-utils';
import { AdequationConfig, Produit } from 'projects/fiche-conseil-lib/src/public-api';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormConfigService {
  public currentFormConfigSubject = new BehaviorSubject<AdequationConfig | null>(null);
  private selectedProduit: Produit | null;
  public selectedProduitSubject = new BehaviorSubject<Produit | null>(null);

  constructor(private queryManager: QueryManagerService) {}

  setAdequationConfig(config: AdequationConfig | null) {
    this.currentFormConfigSubject.next(config);
  }

  setSelectedProduit(produit: Produit | null) {
    this.selectedProduit = produit;
    this.selectedProduitSubject.next(this.selectedProduit);
  }

  getSelectedProduit() {
    return this.selectedProduit;
  }
}
